export const primary = {
  color1: '#D14242',
  color2: '#DE4C47',
  color3: '#AB2E32',
  color4: '#FFF2F0',
  color5: '#F7A79E',
  color6: '#a9aeb3'
};
export const neutral = {
  color1: '#2D3742',
  color2: '#505F79',
  color3: '#5E6C84',
  color4: '#7A869A',
  color5: '#A5ADBA',
  color6: '#B3BAC5',
  color7: '#DFE1E6',
  color8: '#EBECF0',
  color9: '#F4F5F7',
  color10: '#FFFFFF'
};
export const danger = {
  color1: '#E53935',
  color2: '#F44336',
  color3: '#EF9A9A',
  color4: '#D32F2F'
};
export const warning = {
  color1: '#FFB300',
  color2: '#FFC107',
  color3: '#FFECB3',
  color4: '#FFA000'
};
export const success = {
  color1: '#43A047',
  color2: '#4CAF50',
  color3: '#A5D6A7',
  color4: '#388E3C'
};
export const info = {
  color1: '#039BE5',
  color2: '#03A9F4',
  color3: '#81D4FA',
  color4: '#0288D1'
};